module.exports = __webpack_public_path__ + "static/trish-cfb4c3e1695cfce23bc10ac126c71024.jpg";